module.exports = __webpack_public_path__ + "img/img1.bc79a13c.png";